export enum SettingsTypeModel {
  WORKSPACE_SETTINGS = "workspaceSettings",
  ACTIVE_MEMBERS = "activeMembers",
  API_KEYS = "apiKeys",
  INTEGRATIONS = "integrations",
  PLAN_SUBSCRIPTION = "planSubscription",
}
